/** Base URL absensi backend (tanpa trailing slash). */
export const getBackendURL = () => {
    const url = process.env.REACT_APP_BACKEND_URL;
    if (url) {
        return url.replace(/\/$/, '');
    }
    return process.env.NODE_ENV === 'development' ? 'http://localhost:3002' : '';
};

/** Base URL untuk axios (dengan trailing slash). */
export const getBackendBaseURL = () => {
    const url = getBackendURL();
    return url ? `${url}/` : '/';
};

/** URL foto absensi lewat API terproteksi (butuh cookie JWT). */
export const absensiImageUrl = (relativePath) => {
    if (!relativePath) return '';
    const cleaned = String(relativePath).replace(/^\/+/, '').replace(/\\/g, '/');
    if (!cleaned.includes('/')) {
        return `${getBackendURL()}/api/media/absensi-file/${cleaned}`;
    }
    return `${getBackendURL()}/api/media/absensi/${cleaned}`;
};

/** URL foto profil lewat API terproteksi (`username/file.jpg` atau legacy `file.jpg`). */
export const profileImageUrl = (relativePath) => {
    if (!relativePath) return '';
    const cleaned = String(relativePath).replace(/^\/+/, '').replace(/\\/g, '/');
    return `${getBackendURL()}/api/media/profile/${cleaned}`;
};

/** URL dokumen izin/cuti (admin). */
export const documentUrl = (filename) => {
    if (!filename) return '';
    const name = String(filename).replace(/^\/+/, '').split('/').pop();
    return `${getBackendURL()}/api/media/document/${name}`;
};
